var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5 114.639C106.945 114.639 114.677 106.945 114.677 97.4619C114.677 93.7295 113.458 90.2637 111.439 87.4453C108.316 83.1416 103.251 80.2852 97.5381 80.2852C91.8252 80.2852 86.7598 83.1035 83.6367 87.4453C81.6182 90.2637 80.3994 93.7295 80.3994 97.4619C80.3613 106.945 88.0547 114.639 97.5 114.639Z",
    fill: "#7768EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.977 76.5146V62.1182V59.9854H132.844L118.447 60.0234L118.523 76.5527L134.977 76.5146Z",
    fill: "#7768EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16 97.5C124.16 112.201 112.201 124.16 97.5 124.16C82.7988 124.16 70.8398 112.201 70.8398 97.5C70.8398 93.958 71.5635 90.5684 72.8203 87.4834H58.2715V127.397C58.2715 132.539 62.4609 136.729 67.6025 136.729H127.397C132.539 136.729 136.729 132.539 136.729 127.397V87.4834H122.18C123.475 90.5684 124.16 93.958 124.16 97.5Z",
    fill: "#7768EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 0C43.6465 0 0 43.6465 0 97.5C0 151.354 43.6465 195 97.5 195C151.354 195 195 151.354 195 97.5C195 43.6465 151.354 0 97.5 0ZM146.25 87.4834V127.397C146.25 137.795 137.795 146.25 127.397 146.25H67.6025C57.2051 146.25 48.75 137.795 48.75 127.397V87.4834V67.5645C48.75 57.167 57.2051 48.7119 67.6025 48.7119H127.397C137.795 48.7119 146.25 57.167 146.25 67.5645V87.4834Z",
    fill: "#7768EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 195,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.126f3148c1754f7d35b402067c6eb604.svg";
export { ForwardRef as ReactComponent };